// The media namespace (OQ-162): the filters, the media viewer and the selectors on a media item.
export const svMedia = {
  shared: {
    searchPlaceholder: 'Sök…',
    noStatus: 'Ingen status',
    noProject: 'Inget projekt'
  },
  filtersSideMenu: {
    clearAll: 'Rensa alla filter',
    clearAllTitle: 'Ta bort alla aktiva filter och visa alla ärenden',
    showingRead: 'Visar lästa',
    showingUnread: 'Visar olästa',
    showingImage: 'Visar bilder',
    showingVideo: 'Visar videor',
    showingAssignee: 'Visar ansvarig: {{name}}',
    showingNoAssignee: 'Visar ärenden utan ansvarig',
    showingSearch: 'Visar sökord: {{term}}',
    showingStatus: 'Visar status: {{status}}',
    showingNoStatus: 'Visar ärenden utan status',
    showingProject: 'Visar ärenden i projektet: {{project}}',
    showingNoProject: 'Visar ärenden utan projekt',
    showingProjectsByStatus: 'Visar projekt med statusen: {{status}}',
    viewAs: 'Visa som ärenden eller projekt',
    files: 'Ärenden',
    filesTitle: 'Lista ärendena ett och ett',
    projects: 'Projekt',
    projectsTitle: 'Gruppera ärendena per projekt',
    filterProjectsByStatus: 'Filtrera <strong>projekt</strong> på status',
    chooseStatus: 'Välj status',
    searchComments: 'Sök i kommentarer',
    clearSearchTitle: 'Rensa söktexten',
    search: 'Sök',
    searchTitle: 'Filtrera ärenden vars kommentarer innehåller texten',
    filterByDate: 'Filtrera på skapandedatum',
    after: 'Efter',
    before: 'Före',
    datePlaceholder: 'ÅÅÅÅ-MM-DD',
    filterByAssignee: 'Filtrera på ansvarig',
    assigneeTitle: 'Visa bara ärenden som tilldelats en viss person',
    noAssignee: 'Ingen ansvarig',
    chooseAssignee: 'Välj ansvarig',
    noAssigneeTitle: 'Visa bara ärenden som ingen har tilldelats',
    filterNoAssignee: 'Filtrera på ärenden utan ansvarig',
    filterByStatus: 'Filtrera på status',
    statusTitle: 'Visa bara ärenden med en viss status',
    noStatusTitle: 'Visa bara ärenden utan status',
    filterNoStatus: 'Filtrera på ärenden utan status',
    filterByProject: 'Filtrera på projekt',
    projectTitle: 'Visa bara ärenden som hör till ett visst projekt',
    chooseProject: 'Välj projekt',
    noProjectTitle: 'Visa bara ärenden som inte hör till något projekt',
    filterNoProject: 'Filtrera på ärenden utan projekt',
    filterByRead: 'Filtrera på läst eller oläst',
    readTitle: 'Visa bara lästa ärenden',
    read: 'Läst',
    unreadTitle: 'Visa bara olästa ärenden',
    unread: 'Oläst',
    filterByFileType: 'Filtrera på bild eller video',
    imageTitle: 'Visa bara bildärenden',
    image: 'Bild',
    videoTitle: 'Visa bara videoärenden',
    video: 'Video'
  },
  mediaViewer: {
    loading: 'Laddar…',
    notFound: 'Ärendet finns inte',
    errorAlt: 'Fel',
    drawingPin: 'Ritning: {{name}}, sida {{page}}',
    somethingWentWrong: 'Något gick fel. Försök igen senare.',
    somethingWentWrongWithError: 'Något gick fel. Försök igen senare. Fel: {{error}}',
    imageAlt: 'Bilden i ärendet',
    zoomIn: 'Zooma in',
    zoomOut: 'Zooma ut',
    resetZoom: 'Återställ zoom',
    download: 'Ladda ner',
    downloadFailed: 'Kunde inte ladda ner filen.',
    previous: 'Föregående',
    next: 'Nästa',
    position: '{{index}} av {{count}}',
    panel: 'Ärendet',
    status: 'Status',
    project: 'Projekt',
    assignee: 'Ansvarig',
    noComment: 'Ingen intern kommentar'
  },
  statusSelector: {
    changed: 'Statusen har ändrats på ärendet',
    changeFailed: 'Kunde inte ändra statusen på ärendet.',
    unassigned: 'Statusen har kopplats bort från ärendet',
    unassignFailed: 'Kunde inte koppla bort statusen från ärendet.',
    unassign: 'Koppla bort status'
  },
  projectSelector: {
    added: 'Projektet har lagts till på ärendet',
    addFailed: 'Kunde inte lägga till projektet på ärendet.',
    unassigned: 'Projektet har kopplats bort från ärendet',
    unassignFailed: 'Kunde inte koppla bort projektet från ärendet.',
    unassign: 'Koppla bort projekt'
  },
  assigneeSelector: {
    noAssignee: 'Ingen ansvarig',
    assigned: 'Användaren har tilldelats ärendet',
    assignFailed: 'Kunde inte tilldela användaren ärendet.',
    unassigned: 'Användaren är inte längre ansvarig för ärendet',
    unassignFailed: 'Kunde inte koppla bort den ansvariga från ärendet.',
    unassign: 'Koppla bort ansvarig'
  },
  positionPicker: {
    loadFailed: 'Kunde inte ladda kartan.'
  }
};
